var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import KendoBaseComponent from '@progress/kendo-base-component-react-wrapper';

var DateTimePicker = function (_super) {
  __extends(DateTimePicker, _super);

  function DateTimePicker() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DateTimePicker.prototype.componentDidMount = function () {
    var domNode = ReactDOM.findDOMNode(this);

    var _a = this.props,
        children = _a.children,
        widgetRef = _a.widgetRef,
        props = __rest(_a, ["children", "widgetRef"]);

    if (domNode) {
      this.widgetInstance = new kendo.ui.DateTimePicker(domNode, props);

      _super.prototype.componentDidMount.call(this);
    }
  };

  DateTimePicker.prototype.componentWillReceiveProps = function (nextProps) {
    var children = nextProps.children,
        widgetRef = nextProps.widgetRef,
        props = __rest(nextProps, ["children", "widgetRef"]);

    this.widgetInstance.setOptions(props);
    this.widgetInstance.value(props.value);
  };

  DateTimePicker.prototype.render = function () {
    return this.props.children || React.createElement("input", null);
  };

  return DateTimePicker;
}(KendoBaseComponent);

export default DateTimePicker;